





































































































import { CompanyParams } from '@/store/interfaces/company';
import { liquidationKind } from '@/store/interfaces/liquidations';
import { taxPayer } from '@/util/transformString/translationsDecorator';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'ShowCompanyInfo',
  props: {
    company: {
      required: true,
      type: Object as PropType<CompanyParams>,
    },
  },
  data: () => ({
    taxPayer,
  }),
  methods: {
    isValidationKindValid(liquidation: liquidationKind | null): string {
      return liquidation ? liquidation.name : '';
    },
  },
});
